import gql from 'graphql-tag';

// Hooks
import { useQuery } from '@apollo/react-hooks';

// Types
import {
  GetOperationsFiltersQuery,
  GetOperationsFiltersQueryVariables,
} from 'src/app/gql/__generated__/hooks';

export const GET_OPERATIONS_FILTERS = gql(`
  query getOperationsFilters {
    filtersByDeployedProductId {
      operations {
        acids
        aircraftCategories
        aircraftTypes
        airlines
        airportIds
        correlated
        operationTypes
        operatorCategories
        pathnames
        remoteAirportIds
        runwayNames
      }
    }
  }
`);

export const useGetOperationsFilters = (skip = false) => {
  const { data, loading, error } = useQuery<
    GetOperationsFiltersQuery,
    GetOperationsFiltersQueryVariables
  >(GET_OPERATIONS_FILTERS, {
    skip,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: error => {
      console.error('Error fetching operations filters:', error);
    },
  });

  return {
    operationsFilters: data?.filtersByDeployedProductId?.operations,
    loading,
    error,
  };
};
